import React from 'react';
import classnames from 'classnames';
import useBreakpoint from '../../hooks/useBreakpoint';
import { useWizard } from 'react-use-wizard';

interface BreadcrumbsProps {
  children: React.ReactElement<{ name: string }>[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ children }) => {
  const { activeStep } = useWizard();
  const isPhoneOrTablet = useBreakpoint(['xs', 'sm', 'md']);

  if (!children) {
    return null;
  }

  return (
    <div className='Breadcrumbs'>
      {!isPhoneOrTablet ? (
        <div className='BreadcrumbsGuide'>
          {activeStep > 0 && activeStep < children.length && (
            <h6
              className={classnames('stepLabel', { isCurrentStep: activeStep })}
            >{`${activeStep + 1}.${children[activeStep].props.name}`}</h6>
          )}
          {activeStep + 1 < children?.length && (
            <h6 className='stepLabel'>{`${activeStep + 2}.${
              children[activeStep + 1].props.name
            }`}</h6>
          )}
        </div>
      ) : null}
      <div
        className={classnames('BreadcrumbsSteps', {
          'mb-0 mt-3': isPhoneOrTablet,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Breadcrumbs;
